module.exports = __webpack_public_path__ + "img/activity2.876c05b6.png";